import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";

export function useLoanCentricSidebarNavEnabled(): boolean {
  const { data } = useGetFeatureFlagsQuery();
  return data?.loanCentricSidebarNavEnabled === true;
}
